import qs from "query-string";
import React, { useEffect, useState } from "react";
import { usePrimaryOrganizationId } from "../../hooks/useOrganization";
import { AuthPageWrapper } from "../../components/layout/AuthPageWrapper";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { Loading } from "../../components";
import { useSelf } from "../../hooks";
import { NetworkRequest } from "../../../common/models";
import { LOGIN_TARGET_KEY } from "../auth/LoginPage";
import { makeStyles } from "@mui/styles";

const useClasses = makeStyles({
  loginImage: {
    marginLeft: "-80px",
  },
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  logoText: {
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "3px",
  },
});

const SHOPIFY_INTEGRATION_KEY = "POLARIS_SHOPIFY_INTEGRATION";

export const ShopifyIntegrationPage = () => {
  const [self, request] = useSelf();
  const organizationId = usePrimaryOrganizationId();
  const classes = useClasses();

  const [, setLoginTarget] = useLocalStorage(LOGIN_TARGET_KEY, "");
  const [configuringShopifyIntegration, setConfiguringShopifyIntegration] = useLocalStorage(
    SHOPIFY_INTEGRATION_KEY,
    "",
  );

  const [locked, setLocked] = useState(configuringShopifyIntegration == "true");

  useEffect(() => {
    if (locked && self && organizationId) {
      setLocked(false);
    }
  }, [locked, self, organizationId]);

  useEffect(() => {
    if (locked || !NetworkRequest.isFinished(request)) {
      return;
    }
    const query = qs.parse(location.search);
    if (!query?.shop || !query?.hmac) {
      window.location.href = "/";
      return;
    }

    if (!organizationId) {
      const target = `${location.pathname}${location.search}`;
      setLoginTarget(`${location.pathname}${location.search}`);
      setConfiguringShopifyIntegration("true");
      location.href = `/login?target=${encodeURIComponent(target)}`;
      return;
    }

    setLoginTarget("");
    setConfiguringShopifyIntegration("");
    location.href = `/webhooks/oauth/shopify/${organizationId}/start${location.search}`;
  }, [location.search, organizationId, request, locked]);

  return (
    <AuthPageWrapper
      className="no-overflow p-relative"
      imageElement={
        <div className={`page-box__img-wrapper pt-xl ${classes.loginImage}`}>
          <img src="/assets/images/login.svg" className="page-box__img" />
        </div>
      }
    >
      <div className={`${classes.logo} flex-row align-items-center p-lg`}>
        <img
          src="/assets/images/nav-icon-truevault.png"
          className="mr-sm"
          color="primary"
          width="40"
        />
        <span className={`${classes.logoText} text-t1`}>TrueVault</span>
      </div>
      <div className="px-xl text-center flex-row align-items-center w-100">
        <Loading className="mx-auto" />
      </div>
      <div className="w-100">
        <p className="text-t4 text-center w-100">Connecting your Shopify account...</p>
      </div>
    </AuthPageWrapper>
  );
};
